export default __webpack_public_path__ + "static/media/header-XC40.5988106b.jpg";